import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  errorText: {
    fontSize: "12px",
    fontWeight: 400,
    color: "#B30000",
  },
}));
